import { render } from "./NewGpsDevice.vue?vue&type=template&id=40ae5aa1&scoped=true"
import script from "./NewGpsDevice.vue?vue&type=script&lang=js"
export * from "./NewGpsDevice.vue?vue&type=script&lang=js"

import "./NewGpsDevice.vue?vue&type=style&index=0&id=40ae5aa1&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae5aa1"]])

export default __exports__